import { Link } from "react-router-dom";

export default function Categories() {
  return (
    <section className="categories">
      <div className="container">

        <div className="section-header">
          <h2>Our Product Range</h2>
          <p>Discover our natural solutions for holistic wellness and beauty</p>
        </div>

        <div className="category-grid">

          {/* Cosmetics */}
          <div className="category-card">
            <div className="category-img">
              <img 
                src="/assets/categories/cosmetics.png" 
                alt="Cosmetics"
              />
            </div>
            <div className="category-content">
              <h3>Cosmetics</h3>
              <p>Cosmetic essentials designed for healthy, radiant skin.</p>
              <Link to="/products" className="btn btn-secondary">View Products</Link>
            </div>
          </div>

          {/* Skin Care */}
          <div className="category-card">
              <div className="category-img">
                <img 
                  src="/assets/categories/skin-care.png" 
                  alt="Skin Care"
                />
              </div>
              <div className="category-content">
                <h3>Skin Care</h3>
                <p>Natural skincare solutions with our Jojoba-R line.</p>
                <Link to="/products" className="btn btn-secondary">View Products</Link>
              </div>
          </div>

          {/* Nutraceuticals */}
          <div className="category-card">
            <div className="category-img">
              <img 
                src="/assets/categories/nutraceuticals.png" 
                alt="Nutraceuticals"
              />
            </div>
            <div className="category-content">
              <h3>Nutraceuticals</h3>
              <p>Essential vitamins and minerals for overall wellbeing.</p>
              <Link to="/products" className="btn btn-secondary">View Products</Link>
            </div>
          </div>

          {/* Herbals */}
          <div className="category-card">
            <div className="category-img">
              <img 
                src="/assets/categories/herbals.png" 
                alt="Herbals"
              />
            </div>
            <div className="category-content">
              <h3>Herbals</h3>
              <p>Traditional remedies harnessing the power of nature.</p>
              <Link to="/products" className="btn btn-secondary">View Products</Link>
            </div>
          </div>

        </div>

      </div>
    </section>
  );
}
